import { render, staticRenderFns } from "./show.vue?vue&type=template&id=5115859a&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"
import style0 from "./show.vue?vue&type=style&index=0&id=5115859a&prod&lang=css"
import style1 from "./show.vue?vue&type=style&index=1&id=5115859a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5115859a",
  null
  
)

export default component.exports